<template>
    <button type="button" class="d-none" data-toggle="modal" data-target=".renameFolderModals" id="renameFolderBtn"> </button>
    <div class="modal fade renameFolderModals" id="folderModalId" tabindex="-1" role="dialog" aria-hidden="true">
        <div class=" modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <form @submit.prevent="addFolderName" id="createFolder" class="createFolder">
                    <div class="modal-header">
                        <h5 class="modal-title">Rename Folder</h5>
                        <button type="button" class="close" id="closeRenameFolderPop" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group col-md-12">
                            <input type="text" class="form-control" ref="folderInput" name="folderReName" id="folderReName" placeholder="Enter Folder Name" v-model="v$.form.folderReName.$model" >
                            <div class="input-errors" v-for="(error, index) of v$.form.folderReName.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div> 
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary" :disabled="v$.form.$invalid" v-on:click="addReFolderName" v-if="formLoader === 1">Update</button>
                        <button type="button" class="btn btn-primary" :disabled="v$.form.$invalid" v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...</button>
                    </div>
                </form> 
            </div>
        </div>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {
    helpers,
    required,
    minLength
} from '@vuelidate/validators'
import $ from "jquery";
import {
    encodeBase62,
    decodeTextFromBase62,
    decodeBase62,
} from '../../utils/helper.js'

import 
    { postCommon } 
from '../../utils/api.js'

export default {
    name: 'RenameFolderData',
    data() {
        return {
            errorMessage: '',
            formLoader: 1,
            oldFolderpaths: null,
            form: {
                folderReName: '',
            },
        }
    },
    methods: {
        encodeBase62,
        decodeTextFromBase62,
        decodeBase62,
        async addReFolderName() {
            this.formLoader = 2
            let Folderpaths = ''

            let folderName = $('#folderReName').val();
            folderName = folderName.trim();

            if (!this.$route.query.path || this.$route.query.path.trim() === '') {
                Folderpaths = folderName;
            }else{
                const pathParam = this.$route.query.path;

                if (pathParam) {
                    const pathSegments = pathParam.split('/');

                    let newUrl = '';
                    let newAxiosUrl = '';
                    for (let i = 0; i < pathSegments.length; i++) {
                        let tempName = this.decodeTextFromBase62(pathSegments[i]);
                        if( i === 0) {
                            newUrl = tempName;
                            newAxiosUrl = tempName;

                        } else{
                            newUrl = newUrl + '/' + tempName
                            newAxiosUrl = newAxiosUrl + '/' + tempName
                        }
                    }
                    Folderpaths = newAxiosUrl;
                } else {
                    Folderpaths = this.decodeTextFromBase62(this.pathParam);
                }

                Folderpaths = Folderpaths+ '/' + folderName;
            }
            
            let _post = {}
            _post = {
                oldFolderName: this.oldFolderpaths,
                newFolderName: Folderpaths,
            }
            this.addFolder(_post)
        },
        async addFolder(_post) {
            const resp = await postCommon('files/edit-folder', _post)
            if (resp.status == 200 && resp.data.status == 'success') {
                document.getElementById('closeRenameFolderPop').click();
                this.$toast.success(resp.data.message);
                this.$store.state.home.reLoadFolderHomeStarredComponent = Math.random();
            } else if (resp.status == 200 && resp.data.status == 'failure') {
                this.errorMessage = resp.data.message;
                this.$toast.error(resp.data.message);
            }
            this.formLoader = 1
        },
        async renameFolder(name) {
            let Folderpaths = ''
            
            let folderName = name;
            folderName = folderName.trim();
            
            if (!this.$route.query.path || this.$route.query.path.trim() === '') {
                Folderpaths = folderName;
            }else{
                const pathParam = this.$route.query.path;
                if (pathParam) {
                    const pathSegments = pathParam.split('/');
                    
                    let newUrl = '';
                    let newAxiosUrl = '';
                    for (let i = 0; i < pathSegments.length; i++) {
                        let tempName = this.decodeTextFromBase62(pathSegments[i]);
                        if( i === 0) {
                            newUrl = tempName;
                            newAxiosUrl = tempName;
                            
                        } else{
                            newUrl = newUrl + '/' + tempName
                            newAxiosUrl = newAxiosUrl + '/' + tempName
                        }
                    }
                    Folderpaths = newAxiosUrl;
                } else {
                    Folderpaths = this.decodeTextFromBase62(this.pathParam);
                }
                
                Folderpaths = Folderpaths+ '/' + name;
            }
            this.oldFolderpaths = Folderpaths;
            this.form.folderReName = '';
            this.v$.$reset()
             
            document.getElementById('renameFolderBtn').click();
            setTimeout(async () =>
            $("#folderReName").val(name),
            $("#folderReName").focus(),
            500);
            console.log(document.getElementById('folderReName'));

            this.$nextTick(() => {
                this.$refs.folderInput.focus(); // ✅ DOM is now rendered
            });
        }
    },
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    validations() {
        const alphaNumeric = helpers.withMessage(
            'Only letters, numbers, spaces, dots, underscores, and hyphens are allowed.',
            helpers.regex(/^[a-zA-Z0-9 ._-]+$/) // added `_` and `-`
    )
        return {
            form: {
                folderReName: {
                    required,
                    alphaNumeric,
                    min: minLength(2)
                }
            },
        }
    },
}
</script>
